module.exports = __webpack_public_path__ + "static/media/logo.dad4a114.svg";